const MODERATION_MESSAGES: Record<string, string> = {
  'device-incompatible': 'This device cannot run the required safety checks. Please switch to a newer device or desktop browser.',
  'device_incompatible': 'This device cannot run the required safety checks. Please switch to a newer device or desktop browser.',
  'nsfw-threshold-exceeded': 'This media appears to violate Belivah\'s modesty guidelines. Choose a different photo or video.',
  'nsfw_threshold_exceeded': 'This media appears to violate Belivah\'s modesty guidelines. Choose a different photo or video.',
  'nsfw_blocked': 'This media was not published because it appears to contain nudity or sexual content, which Belivah does not allow. Normal photos of people, weddings, church events, sport and appropriate swimwear are fine. If you believe this is a mistake, you can request a review when uploading, or see Help > Appeals.',
  'moderation_unavailable': 'Our safety check is temporarily unavailable. Please try again in a few minutes.',
  'moderation_proof_required': 'We could not verify this upload. Please upload the media again.',
  'moderation_proof_invalid': 'This upload check expired. Please upload the media again.',
  'auth-required': 'Your session expired. Please sign in again to upload media.',
  'unauthenticated': 'Your session expired. Please sign in again to upload media.',
  'permission-denied': 'You do not have permission to upload on behalf of another account. Please reload and try again.',
  'path_must_include_uid': 'You do not have permission to upload on behalf of another account. Please reload and try again.',
  'moderation-token-missing': 'We could not verify this upload. Please try again.',
  'file_too_large': 'This file is larger than 500 MB. Please choose a smaller or compressed file.',
};

function normalize(value?: string | null) {
  return (value || '').trim().toLowerCase();
}

export function describeModerationError(error: unknown): string | null {
  if (!error) return null;
  const code = normalize((error as any)?.code);
  const message = normalize(
    typeof error === 'string'
      ? error
      : error instanceof Error
        ? error.message
        : (error as any)?.message
  );

  if (code === 'nsfw_blocked' && (error as any)?.appealSubmitted) {
    return 'This media was not published. Your review request was sent to our moderators.';
  }
  if (code && MODERATION_MESSAGES[code]) {
    return MODERATION_MESSAGES[code];
  }
  if (message && MODERATION_MESSAGES[message]) {
    return MODERATION_MESSAGES[message];
  }

  if (message.includes('device') && message.includes('incompatible')) {
    return MODERATION_MESSAGES['device-incompatible'];
  }
  if (message.includes('nsfw')) {
    return MODERATION_MESSAGES['nsfw_blocked'];
  }
  if (message.includes('unauth') || code === '401') {
    return MODERATION_MESSAGES['auth-required'];
  }
  if (message.includes('permission') || code === '403') {
    return MODERATION_MESSAGES['permission-denied'];
  }

  return null;
}

export function notifyIfHeldForReview(item: unknown) {
  const status = (item as any)?.moderation?.status;
  if (status === 'pending_review') {
    window.alert('Thanks for sharing! Our safety check could not fully confirm this media, so a moderator will review it shortly. Until then, only you can see it.');
  }
}
